module.exports = __webpack_public_path__ + "static/media/rp.27ddb1e9.svg";